import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProductCatalog from './pages/product-catalog';
import LoginPage from './pages/login';
import ProductDetails from './pages/product-details';
import Dashboard from './pages/dashboard';
import Reports from './pages/reports';
import { AuthProvider, useAuth } from './AuthProvider';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Help from './pages/Help';
import ActivityLog from './pages/activity-log';
import Layout from './components/ui/Layout';
import ForgotPassword from './pages/forgot-password';
import SoldItems from './pages/sold-items';

// import PurchaseOrder from './pages/purchase-order';
// import PurchaseOrderList from './pages/purchase-order/list';
import Checkout from './pages/checkout';
import CheckoutItemDetails from './pages/checkout-item';

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex items-center space-x-3 text-muted-foreground">
        <div className="w-4 h-4 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        <span>Loading...</span>
      </div>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  const allowGuest = import.meta.env.DEV;
  return (user || allowGuest) ? children : <Navigate to="/login" replace />;
}

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <AuthProvider>
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
        <Route path="/product-catalog" element={<ProtectedRoute><Layout><ProductCatalog /></Layout></ProtectedRoute>} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/product-details/:id" element={<ProtectedRoute><Layout><ProductDetails /></Layout></ProtectedRoute>} />
        {/* Removed purchase order routes */}
        {/* <Route path="/purchase-orders" element={<ProtectedRoute><Layout><PurchaseOrderList /></Layout></ProtectedRoute>} /> */}
        {/* <Route path="/purchase-order/new" element={<ProtectedRoute><Layout><PurchaseOrder /></Layout></ProtectedRoute>} /> */}
        {/* <Route path="/purchase-order/:id" element={<ProtectedRoute><Layout><PurchaseOrder /></Layout></ProtectedRoute>} /> */}
        {/* <Route path="/purchase-order" element={<ProtectedRoute><Layout><PurchaseOrder /></Layout></ProtectedRoute>} /> */}
        <Route path="/checkout" element={<ProtectedRoute><Layout><Checkout /></Layout></ProtectedRoute>} />
        <Route path="/checkout-item/:id" element={<ProtectedRoute><Layout><CheckoutItemDetails /></Layout></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute><Layout><Reports /></Layout></ProtectedRoute>} />
        {/* <Route path="/purchase-order" element={<ProtectedRoute><Layout><PurchaseOrder /></Layout></ProtectedRoute>} /> */}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/activity-log" element={<ProtectedRoute><Layout><ActivityLog /></Layout></ProtectedRoute>} />
        <Route path="/sold-items" element={<ProtectedRoute><Layout><SoldItems /></Layout></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
        <Route path="/help" element={<ProtectedRoute><Layout><Help /></Layout></ProtectedRoute>} />

        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
